// Design tokens — light/dark adaptive via CSS custom properties from index.html.

export const SIG = {
  STRONG:    { fg: "#22c55e", bg: "rgba(34,197,94,0.10)",   border: "rgba(34,197,94,0.30)" },
  MODERATE:  { fg: "#f59e0b", bg: "rgba(245,158,11,0.10)",  border: "rgba(245,158,11,0.30)" },
  WATCH:     { fg: "#60a5fa", bg: "rgba(96,165,250,0.10)",  border: "rgba(96,165,250,0.30)" },
  NO_SIGNAL: { fg: "#71717a", bg: "rgba(113,113,122,0.07)", border: "rgba(113,113,122,0.20)" },
};

export const T = {
  mono: "var(--font-mono)",
  sans: "var(--font-sans)",
  bg1: "var(--surface-1)",
  bg2: "var(--surface-2)",
  border: "var(--border)",
  borderStrong: "var(--border-strong)",
  textPrimary: "var(--text-primary)",
  textSecondary: "var(--text-secondary)",
  textMuted: "var(--text-muted)",
};

export const sig = (s) => SIG[s] || SIG.NO_SIGNAL;
